module.exports = __webpack_public_path__ + "static/media/sa.01c13e57.png";